// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
//   apiUrl: 'http://145.239.76.86:7151/galactus/v1/',
//   apiUrl: 'http://localhost:8080/galactus-webapp/v1/',
export const environment = {
  production: false,
  // TODO CHE FA QUESTO? apiUrl: 'https://gestionale.galactus.it/api/',
  // TODO CHE FA QUESTO? apiUrl: 'http://galactus.ant-lab.it/api/',
  // TODO CHE FA QUESTO? apiUrl: 'http://localhost:8080/v1/',
  // per il test --> https://kube-gestionale-test.galactus.it/api
  // apiUrl: 'https://kube-gestionale-dev.galactus.it/api',
  apiUrl: 'https://gestionale.dev.galactus.it/api/',
  homePage: '/home',
  loginPage: '/auth/login',
  defaultLang: 'en',
  authToken : 'Authorization',
  datePattern : 'DD/MM/YYYY',


  apiKey: 'Api-Key',
  apiKeyValue: 'jgfre80gj9e8hjh998dbjpdvfdh456',
  // Refresh via the v1 shim: /api/refresh -> ingress -> /v1/refresh (the dev ingress
  // rewrites /api -> /v1 and does not expose /v2). apiUrl already ends in '/'.
  refreshUrl: 'https://gestionale.dev.galactus.it/api/refresh',

  constants: {
    rebalanceEnabled: true,
    sbragaTuttoEnabled: false,
    minCardAutocompleteLength: 3,
    minEditionAutocompleteLength: 2,
    pageFirst: 0,
    pageSize: 20,
    defaultLanguageId : 4,
    setInsertDefaultDisposition: 'table',

    cardLanguages: [
      {id: 0, name: 'English'},
      {id: 1, name: 'English/French'},
      {id: 2, name: 'English/German'},
      {id: 3, name: 'English/Spanish'},
      {id: 4, name: 'English/Italian'}
      ],
    priceRuleNotificationOperations: [
      'NO_PRICE',
      'PRICE_UP',
      'PRICE_DOWN'
    ],
    notificationStatuses: [
      'NEW',
      //'READ',
      'ANSWERED'
    ],
    priceRuleStatuses: [
      'ACCEPTED',
      'POSTPONED',
      'DISCARDED'
    ],
    stockStatuses: [
      'UNDERSTOCK',
      'OVERSTOCK',
      'NORMAL'
    ],
    profiles: {
      ADMIN_PROFILE : 'admin'
    },
    sessionTypes: {
      CARICO: 'IN',
      SCARICO: 'OUT',
      TRASFERIMENTO: 'TRANS'
    },
    sessionStates: {
      OPEN: 1,
      WAITING_APP: 2,
      APPROVED: 3,
      COMPLETE : 4
    },

    orderStates: {
      OPEN: 1,
      CONFIRMED: 2,
      COMPLETED: 3
    },

    marketOrderStates: {
      BOUGHT: 1,
      PAID: 2,
      SENT: 4,
      RECEIVED: 8,
      LOST: 32,
      CANCELLED: 128
    },

    MKM_ORDER : 'MKM_ORDER',
    cardTypes:  ['foil', 'firstEdition', 'signed', 'stamped', 'inked', 'altered',  'shadowless', 'staff']
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts